import * as React from 'react';
import styled from 'styled-components';

import { SingleBlock as SB } from '@process-advisor/process-miner/components/layout/singleBlock';
import { Button } from '@process-advisor/process-miner/components/shared/button';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { getShadow, getZIndex } from '@process-advisor/process-miner/shared/theme';
import { StatusGrid } from '@process-advisor/process-miner/filters/status/statusGrid';
import { openProgressModal } from '@process-advisor/process-miner/api/methods/modals/openProgressModal';
import { closeProgressModal } from '@process-advisor/process-miner/api/methods/modals/closeProgressModal';

export const SingleBlock = styled(SB)`
    align-items: center;
`;

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
`;

export const Status = ({type}) => {
    const [deleteDisabled,setDeleteDisabled,] = React.useState<boolean>(true);
    const [applyEnabled, setApplyEnabled] = React.useState<boolean>(true);
    const [label,setLabel] = React.useState('');
    const sleep = ms => new Promise(r => setTimeout(r, ms));

    async function onDelete () {
        if (type === 'discovery') openProgressModal({status: 'Deleting Discovery'})
        if (type === 'filter') openProgressModal({status: 'Deleting Filter'})
        await sleep(50)
        apiProvider.deleteFilter({type: type});
        closeProgressModal()
    };

    React.useEffect(() => {
        setLabel('Delete ' + type)
    }, []);
    
    return (
        <Wrapper>
            <SingleBlock>
                <StatusGrid setApplyEnabled={setApplyEnabled} setDeleteDisabled={setDeleteDisabled} type={type}/>
            </SingleBlock>
            <SingleBlock width="100%">
                <Button label={label} onClick={onDelete} disabled={deleteDisabled}/>
            </SingleBlock>
        </Wrapper>
    );
};
